// Lume — abas do "Como sua vida com Lume vai funcionar".
// Troca o painel visível ao clicar ou navegar pelo teclado, seguindo o
// padrão ARIA de tablist (setas para mover, Home/End para as pontas).

class LumeTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length === 0) return;

    this.addEventListener('click', (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.select(this.tabs.indexOf(tab));
    });

    this.addEventListener('keydown', (event) => {
      const current = this.tabs.indexOf(document.activeElement);
      if (current === -1) return;
      const last = this.tabs.length - 1;
      let next = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = current === last ? 0 : current + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = current === 0 ? last : current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;

      if (next !== null) {
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }
    });
  }

  select(index) {
    if (index < 0 || index >= this.tabs.length) return;
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}

if (!customElements.get('lume-tabs')) customElements.define('lume-tabs', LumeTabs);
